<div class="component-container d-flex flex-column align-items-center justify-content-center gap-3" (click)="pickFiles()" [class.invalid]="isInvalid">
  <div class="chip-icon primary small"><div class="inner"><i class="ti ti-cloud-upload"></i></div></div>
  <div class="inner">
    <p><span class="special-color">Cliquez pour ajouter</span> un fichier</p>
    <small class="extensions">{{ extensionsFormatted() }}</small>
  </div>
</div>
